import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../styles/Navbar.css";
import logo from "../assets/images_processed.jpeg";

function Navbar() {
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);

    // Handle scroll for navbar background
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    // Toggle menu open/close state
    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    return (
        <nav className={`navbar ${scrolled ? "scrolled" : ""}`}>
            <div className="navbar-container">
                <div className="navbar-logo">
                    <img src={logo} alt="Sol Cafe & Lounge" />
                </div>

                {/* Hamburger Icon */}
                <div className={`hamburger ${menuOpen ? "active" : ""}`} onClick={toggleMenu}>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>

                {/* Nav Links */}
                <ul className={`nav-links ${menuOpen ? "open" : ""}`}>
                    <li>
                        <Link to="/" className="nav-link" onClick={() => setMenuOpen(false)}>
                            Home
                        </Link>
                    </li>
                    <li>
                        <Link to="/about" className="nav-link" onClick={() => setMenuOpen(false)}>
                            About Us
                        </Link>
                    </li>
                    <li>
                        <Link to="/bottleservice" className="nav-link" onClick={() => setMenuOpen(false)}>
                            Bottle Service
                        </Link>
                    </li>
                    <li>
                        <Link to="/menu" className="nav-link" onClick={() => setMenuOpen(false)}>
                            Menu
                        </Link>
                    </li>
                    <li>
                        <Link to="/events" className="nav-link" onClick={() => setMenuOpen(false)}>
                            Events
                        </Link>
                    </li>
                    <li>
                        <Link to="/reserve" className="nav-link reserve-link" onClick={() => setMenuOpen(false)}>
                            Reserve
                        </Link>
                    </li>
                </ul>
            </div>
        </nav>
    );
}

export default Navbar;
